import { faCircleCheck, faCirclePlus } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { alpha, Chip } from '@mui/material'
import { getTestId } from '@utils/helpers'

export default function ContractChip({ onContract, ...rest }: { onContract: boolean }) {
	const testId = getTestId(rest, onContract ? 'on-contract-chip' : 'contract-to-load-chip')
	const chipColor = onContract ? 'success.dark' : 'secondary.dark'
	const chipBackground = (theme) =>
		alpha(onContract ? theme.palette.success.dark : theme.palette.secondary.dark, 0.08)

	return (
		<Chip
			icon={<FontAwesomeIcon icon={onContract ? faCircleCheck : faCirclePlus} color={chipColor} />}
			label={onContract ? 'On Contract' : 'Contract to Load'}
			data-testid={testId}
			sx={{ width: 'fit-content', color: chipColor, bgcolor: chipBackground }}
		/>
	)
}
